import { createContext, useContext, useState, useCallback } from "react";
import { translate, LANGS } from "@/lib/i18n";

const I18nContext = createContext(null);

const SUPPORTED = ["pl", "en", "de", "uk"];
function detectLang() {
  const saved = localStorage.getItem("fp_lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const navLangs = navigator.languages || [navigator.language || "pl"];
  for (const l of navLangs) {
    const code = String(l).slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(code)) return code;
  }
  return "pl";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  const setLang = useCallback((code) => {
    localStorage.setItem("fp_lang", code);
    setLangState(code);
    try { document.documentElement.lang = code; } catch {}
  }, []);

  const t = useCallback((s) => translate(lang, s), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () =>
  useContext(I18nContext) || { lang: "pl", setLang: () => {}, t: (s) => s, langs: LANGS };
